import { useBaseStore } from '@common/stores/storage';
import { nativeCrawlerMethods } from './nativeCrawlerMethods';

function getProductCode(channel) {
  // 渠道对应产品编号字典
  const productCodeDic = {
    MS_ZFB_KMR: '5403',
    icbc: '5505',
  };
  return productCodeDic[channel] ? productCodeDic[channel] : '5105';
}

// GPS信息上报
// TODO: 类型定义应该放在
export const gpsSendData = {
  count: 0,
  /**
   * 埋点上报方法
   * @param data bdata: 业务数据
   * @param ecode eventCode: 事件code
   * @param msgId msgId：上传记录唯一标识
   */
  track(data, ecode, msgId) {
    const { channel, userId, uniqueId } = useBaseStore();

    // TODO: 这里msgId 会在axios header当中上传，因此这里要设置一下 window.msgId
    // 尚且不清楚 msgId 在请求 header当中的用途
    if (msgId && !window.afMsgId) {
      window.afMsgId = msgId;
    }

    const afMsgId = msgId || window.afMsgId || '';

    //指纹采集
    const matDATA = {
      bdata: data, //业务数据
      ecode: '' + ecode, // 事件编码
      ccode: channel, // 渠道编码
      userId: userId, // 用户userId
      uniqueId: '' + uniqueId, // 用户uniqueId
      productCode: getProductCode(channel), // 产品编号
      msgId: afMsgId, // 上传记录唯一标识
    };

    window.__mat.push(['__trackGPSEvent', matDATA]);
  },
  // 语音通话采集
  uploadVoice(data) {
    const { channel, userId, uniqueId } = useBaseStore();

    const matDATA = {
      bdata: data.bdata || {},
      ccode: channel, // 渠道编码
      uniqueId,
      busiProcess: data.busiProcess || '',
      pageCode: data.pageCode || '',
      pageName: data.pageName || '',
    };

    if (userId) {
      matDATA['userId'] = userId;
    }

    window.__mat.push(['_uploadVoice', matDATA]);
  },
};
